import "./base-flyout.css";

import type { ReactNode } from "react";
import { memo } from "react";

export type BaseFlyoutProps = {
	isOpen: boolean;
	onClose: () => void;
	title: string;
	children: ReactNode;
	headerActions?: ReactNode;
	width?: string;
	panelClassName?: string;
	isMobile?: boolean;
};

export const BaseFlyout = memo(
	({
		isOpen,
		onClose,
		title,
		children,
		headerActions,
		width = "80vw",
		panelClassName,
		isMobile = false,
	}: BaseFlyoutProps) => {
		const buttonStyle = isMobile
			? "k-button k-button-md k-rounded-sm k-button-solid k-button-solid-base"
			: "k-button k-button-md k-rounded-md k-button-solid k-button-solid-base";
		return (
			<>
				{/* Overlay backdrop */}
				<div
					aria-hidden={!isOpen}
					className={`overlay-backdrop ${isOpen ? "open-flyout-backdrop" : ""}`}
					onClick={onClose}
					onKeyDown={(e) => {
						if (e.key === "Escape") {
							onClose();
						}
					}}
					role={"button"}
					tabIndex={-1}
				/>

				{/* Flyout panel */}
				<div
					className={`flyout-panel ${isOpen ? "open-flyout-panel" : ""} ${panelClassName ?? ""}`}
					style={{ width }}
				>
					<div className={"flyout-header"}>
						<h1>{title}</h1>
						<div className={"flyout-btn-group"}>
							{headerActions}
							<button
								className={`${buttonStyle} flyout-close-btn`}
								onClick={onClose}
							>
								Close
							</button>
						</div>
					</div>
					<div className={"flyout-content-container"}>{children}</div>
				</div>
			</>
		);
	},
);

BaseFlyout.displayName = "BaseFlyout";
